// Co-located translations for statements
// Registered dynamically when component loads
const statementsTranslations = {
  "en": {
    "revenue.title": "Property & Revenue Assumptions",
    "revenue.description": "Configure your investment property and rental income assumptions.",
    "revenue.propertyType": "Property Type",
    "revenue.eigentumswohnung": "Apartment (ETW)",
    "revenue.einfamilienhaus": "Single-Family House",
    "revenue.mehrfamilienhaus": "Multi-Family House",
    "revenue.bundesland": "Bundesland",
    "revenue.city": "City",
    "revenue.noCityData": "No city data available",
    "revenue.squareMeters": "Living Area (m\u00b2)",
    "revenue.numberOfUnits": "Number of Units",
    "revenue.yearBuilt": "Year Built",
    "revenue.landShare": "Land Share %",
    "revenue.landShare.tooltip": "Percentage of purchase price attributable to land (non-depreciable)",
    "revenue.taxEntity": "Tax Entity",
    "revenue.entityType": "Entity Type",
    "revenue.personalTaxRate": "Personal Tax Rate",
    "revenue.rentalModel": "Rental Model",
    "revenue.rentalType": "Rental Type",
    "revenue.longterm": "Long-Term (Dauervermietung)",
    "revenue.shortterm": "Short-Term (Airbnb/Ferienwohnung)",
    "revenue.kaltmietePerSqm": "Cold Rent per m\u00b2",
    "revenue.vacancyRate": "Vacancy Rate",
    "revenue.rentIncreaseType": "Rent Increase Model",
    "revenue.rentRegular": "Regular (\u00a7558 Kappungsgrenze)",
    "revenue.rentIndex": "Indexmiete (CPI-linked)",
    "revenue.rentStaffel": "Staffelmiete (Fixed Steps)",
    "revenue.cpiGrowth": "CPI Growth Rate",
    "revenue.staffelAmount": "Annual Step Increase",
    "revenue.nightlyRate": "Nightly Rate",
    "revenue.availableNights": "Available Nights/Year",
    "revenue.occupancyRate": "Occupancy Rate",
    "revenue.platformFee": "Platform Fee",
    "revenue.mietpreisbremseActive": "Mietpreisbremse is active in this area. New rental contracts are capped at 10% above the local Mietspiegel.",
    "revenue.horizonYears": "Projection Horizon (Years)",
    "revenue.inflationRate": "Annual Inflation",
    "revenue.appreciationRate": "Property Appreciation",
    "revenue.landAppreciationRate": "Land Appreciation",
    "revenue.buildingAppreciationRate": "Building Appreciation",
    "revenue.revenueSummary": "Revenue Summary (Year 1)",
    "revenue.grossRent": "Gross Annual Rent",
    "revenue.vacancyLoss": "Vacancy Loss",
    "revenue.grossBookings": "Gross Bookings",
    "revenue.platformFees": "Platform Fees",
    "revenue.netRentalIncome": "Net Rental Income",
    "revenue.usedInPL": "Used in P&L",
    "revenue.bruttomietrendite": "Gross Rental Yield (Bruttomietrendite)",
    "pl.title": "Profit & Loss Statement",
    "pl.subtitle": "{years}-Year Projection",
    "pl.lineItem": "Line Item",
    "pl.year": "Year {year}",
    "pl.revenue": "REVENUE",
    "pl.rentalIncome": "Rental Income",
    "pl.costOfRevenue": "COST OF REVENUE",
    "pl.maintenance": "Maintenance & Repairs",
    "pl.grossProfit": "Gross Profit",
    "pl.operatingExpenses": "OPERATING EXPENSES",
    "pl.fixedOperatingCosts": "Fixed Operating Costs",
    "pl.renovationExpense": "Renovation Expense",
    "pl.reserveContribution": "Reserve Contribution",
    "pl.scheduledCapex": "Scheduled CapEx",
    "pl.ebitda": "EBITDA",
    "pl.nonCashItems": "NON-CASH ITEMS",
    "pl.depreciation": "Depreciation (AfA)",
    "pl.ebit": "EBIT",
    "pl.financing": "FINANCING",
    "pl.interestExpense": "Interest Expense",
    "pl.ebt": "EBT (Pre-Tax Income)",
    "pl.tax": "TAX",
    "pl.incomeTax": "Income Tax (Einkommensteuer)",
    "pl.corporateTax": "Corporate Tax (KSt + GewSt)",
    "pl.netIncome": "Net Income",
    "pl.cashFlowSummary": "CASH FLOW SUMMARY",
    "pl.cashFromOperations": "Cash from Operations",
    "pl.cashFromInvesting": "Cash from Investing",
    "pl.cashFromFinancing": "Cash from Financing",
    "pl.freeCashFlow": "Free Cash Flow",
    "pl.notes": "Notes",
    "pl.ebitdaNote": "Earnings before interest, taxes, depreciation, and amortization",
    "pl.ebitNote": "Operating profit after depreciation",
    "pl.freeCashFlowNote": "Actual cash generated/consumed (what goes in/out of bank)",
    "pl.afaNote": "Depreciation (AfA) rate based on building age and method. Land is not depreciable.",
    "bs.title": "Balance Sheet",
    "bs.subtitle": "End of Year Position",
    "bs.account": "Account",
    "bs.year": "Year {year}",
    "bs.assets": "ASSETS",
    "bs.landValue": "Land Value",
    "bs.buildingBookValue": "Building (Book Value)",
    "bs.propertyBookValue": "Property (Book Value)",
    "bs.cash": "Cash",
    "bs.reserveFund": "Reserve Fund",
    "bs.totalAssets": "Total Assets",
    "bs.liabilities": "LIABILITIES",
    "bs.loanBalance": "Loan Balance",
    "bs.totalLiabilities": "Total Liabilities",
    "bs.equity": "EQUITY",
    "bs.initialInvestment": "Initial Investment",
    "bs.retainedEarnings": "Retained Earnings",
    "bs.totalEquity": "Total Equity",
    "bs.economicEquity": "Equity at Market Value (NAV)",
    "bs.checkBalance": "Check: Assets = Liab + Equity",
    "bs.marketValueSection": "MARKET VALUE (Not on Balance Sheet)",
    "bs.landMarketValue": "Land (Market Value)",
    "bs.buildingMarketValue": "Building (Market Value)",
    "bs.estimatedMarketValue": "Estimated Market Value",
    "bs.unrealizedGain": "Unrealized Gain (Stille Reserven)",
    "bs.ltv": "Loan-to-Value (LTV)",
    "bs.nav": "Net Asset Value (NAV)",
    "bs.bookVsMarketDelta": "Book vs Market Delta",
    "bs.notes": "Notes",
    "bs.landValueNote": "Land value is constant (not depreciable). Based on land share % of purchase price.",
    "bs.buildingBookValueNote": "Building acquisition cost minus accumulated depreciation (AfA)",
    "bs.marketValueNote": "Estimated market value based on annual appreciation rate (not on balance sheet until sold)",
    "bs.cashNote": "Cumulative free cash flow from operations",
    "bs.reserveFundNote": "Accumulated emergency reserves (Instandhaltungsrücklage)",
    "bs.retainedEarningsNote": "Cumulative net income since acquisition",
    "bs.ltvNote": "Loan as % of market value. Decreases via repayment and appreciation.",
    "bs.navNote": "Market value + cash + reserves − loan. Your true economic net worth.",

    "revenue.energieausweis": "Energieausweis Class",
    "revenue.heatingType": "Heating Type",
    "revenue.heating.gas": "Gas",
    "revenue.heating.oil": "Oil",
    "revenue.heating.district": "District Heating",
    "revenue.heating.electric": "Electric / Heat Pump",
    "revenue.heating.pellet": "Pellet / Biomass",
    "revenue.kommanditeinlage": "Kommanditeinlage (\u00a715a)",
    "revenue.vatSection": "VAT (Umsatzsteuer)",
    "revenue.vatLiable": "VAT Liability",
    "revenue.vatAuto": "Auto (>\u20ac25k = liable)",
    "revenue.vatYes": "Yes (opt-in)",
    "revenue.vatNo": "No (Kleinunternehmer)",
    "revenue.hotelServices": "Hotel-Like Services",
    "revenue.eigennutzung": "Personal Use (Eigennutzung)",
    "revenue.yes": "Yes",
    "revenue.no": "No",
    "revenue.vatAutoHint": "Kleinunternehmerregelung: Below \u20ac25,000/year revenue, no VAT is charged. Above this threshold, 7% USt applies to accommodation.",

    "revenue.kirchensteuer": "Church Tax (Kirchensteuer)",
    "revenue.kirchensteuerNote": "8% in Bayern/Baden-W\u00fcrttemberg, 9% elsewhere. Only for natural persons.",
    "revenue.otherIncome": "Other Annual Income",
    "revenue.otherIncomeHint": "Salary or other income for marginal tax bracket calculation",

    "pl.werbungskosten": "Werbungskosten (Deductions)",
    "pl.co2LandlordCost": "CO\u2082 Cost (Landlord Share)",
    "pl.lossOffset": "Loss Carry-Forward Offset",
    "pl.vatSection": "VAT (BALANCE-SHEET NEUTRAL)",
    "pl.vatCollected": "USt Collected (7%)",
    "pl.vatInputDeduction": "Vorsteuerabzug (Input VAT)",
    "pl.netVAT": "Net VAT Liability",

    "warning.gewerblich": "Gewerblicher Grundst\u00fcckshandel: Selling within 10 years as a private entity may trigger commercial property dealer status (3-object rule). Consider holding longer.",
    "warning.immo_gmbh_shortterm": "Immo-GmbH + Short-Term Rental: Short-term rental disqualifies the erweiterte Gew.St-K\u00fcrzung. The entity will be taxed as a regular GmbH (full GewSt applies).",
    "warning.mopeg": "MoPeG 2026: Since Jan 1, 2024, GmbH & Co. KGs must register in the Gesellschaftsregister. Verify your registration is complete.",
    "warning.geg_heating": "GEG Heating: Buildings built before 1994 may have oil/gas heating systems that must be replaced under the Geb\u00e4udeenergiegesetz. Budget for heating modernization.",
    "warning.gewst_shortterm": "GewSt Risk: Providing hotel-like services (cleaning, linen, breakfast) as a private person triggers Gewerbesteuer on short-term rental income (\u20ac24,500 Freibetrag applies).",
    "warning.section15a": "\u00a715a EStG: Your debt exceeds the Kommanditeinlage. Losses beyond your capital account are not immediately deductible (verrechenbare Verluste).",
    "warning.highLTV": "High Leverage: Debt exceeds 80% of purchase price. Banks may require higher interest rates or additional collateral. Consider increasing equity.",
    "warning.lowDSCR": "Low Debt Service Coverage: Annual rent covers less than 125% of loan payments. Cash flow shortfalls are likely in early years. Ensure sufficient reserves.",
    "warning.abgeltungsteuer": "Dividend Tax: Profits shown are after corporate tax (15.825%). When withdrawn as dividends, an additional 26.375% Abgeltungsteuer applies at the personal level (effective combined rate ~48.3%)."
  },
  "de": {
    "revenue.title": "Immobilien- & Umsatzannahmen",
    "revenue.description": "Konfigurieren Sie Ihre Anlageimmobilie und Mieteinnahmen-Annahmen.",
    "revenue.propertyType": "Immobilienart",
    "revenue.eigentumswohnung": "Eigentumswohnung (ETW)",
    "revenue.einfamilienhaus": "Einfamilienhaus",
    "revenue.mehrfamilienhaus": "Mehrfamilienhaus",
    "revenue.bundesland": "Bundesland",
    "revenue.city": "Stadt",
    "revenue.noCityData": "Keine Stadtdaten verf\u00fcgbar",
    "revenue.squareMeters": "Wohnfl\u00e4che (m\u00b2)",
    "revenue.numberOfUnits": "Anzahl Einheiten",
    "revenue.yearBuilt": "Baujahr",
    "revenue.landShare": "Grundst\u00fccksanteil %",
    "revenue.landShare.tooltip": "Prozentualer Anteil des Kaufpreises f\u00fcr das Grundst\u00fcck (nicht abschreibbar)",
    "revenue.taxEntity": "Steuerliche Struktur",
    "revenue.entityType": "Rechtsform",
    "revenue.personalTaxRate": "Pers\u00f6nlicher Steuersatz",
    "revenue.rentalModel": "Vermietungsmodell",
    "revenue.rentalType": "Vermietungsart",
    "revenue.longterm": "Langzeitvermietung (Dauervermietung)",
    "revenue.shortterm": "Kurzzeitvermietung (Airbnb/Ferienwohnung)",
    "revenue.kaltmietePerSqm": "Kaltmiete pro m\u00b2",
    "revenue.vacancyRate": "Leerstandsquote",
    "revenue.rentIncreaseType": "Mieterh\u00f6hungsmodell",
    "revenue.rentRegular": "Regul\u00e4r (\u00a7558 Kappungsgrenze)",
    "revenue.rentIndex": "Indexmiete (VPI-gebunden)",
    "revenue.rentStaffel": "Staffelmiete (Feste Stufen)",
    "revenue.cpiGrowth": "VPI-Wachstumsrate",
    "revenue.staffelAmount": "J\u00e4hrliche Staffelerh\u00f6hung",
    "revenue.nightlyRate": "\u00dcbernachtungspreis",
    "revenue.availableNights": "Verf\u00fcgbare N\u00e4chte/Jahr",
    "revenue.occupancyRate": "Auslastungsrate",
    "revenue.platformFee": "Plattformgeb\u00fchr",
    "revenue.mietpreisbremseActive": "Mietpreisbremse ist in dieser Gegend aktiv. Neue Mietvertr\u00e4ge sind auf 10% \u00fcber dem \u00f6rtlichen Mietspiegel begrenzt.",
    "revenue.horizonYears": "Prognosehorizont (Jahre)",
    "revenue.inflationRate": "J\u00e4hrliche Inflation",
    "revenue.appreciationRate": "Wertsteigerung",
    "revenue.landAppreciationRate": "Wertsteigerung Grundstück",
    "revenue.buildingAppreciationRate": "Wertsteigerung Gebäude",
    "revenue.revenueSummary": "Umsatz\u00fcbersicht (Jahr 1)",
    "revenue.grossRent": "Brutto-Jahresmiete",
    "revenue.vacancyLoss": "Leerstandsverlust",
    "revenue.grossBookings": "Brutto-Buchungen",
    "revenue.platformFees": "Plattformgeb\u00fchren",
    "revenue.netRentalIncome": "Netto-Mieteinnahmen",
    "revenue.usedInPL": "Verwendet in GuV",
    "revenue.bruttomietrendite": "Bruttomietrendite",
    "pl.title": "Gewinn- und Verlustrechnung",
    "pl.subtitle": "{years}-Jahres-Prognose",
    "pl.lineItem": "Position",
    "pl.year": "Jahr {year}",
    "pl.revenue": "UMSATZ",
    "pl.rentalIncome": "Mieteinnahmen",
    "pl.costOfRevenue": "UMSATZKOSTEN",
    "pl.maintenance": "Instandhaltung & Reparaturen",
    "pl.grossProfit": "Bruttogewinn",
    "pl.operatingExpenses": "BETRIEBSKOSTEN",
    "pl.fixedOperatingCosts": "Fixe Betriebskosten",
    "pl.renovationExpense": "Renovierungsaufwand",
    "pl.reserveContribution": "R\u00fccklage",
    "pl.scheduledCapex": "Geplante Investitionen",
    "pl.ebitda": "EBITDA",
    "pl.nonCashItems": "NICHT-CASH-POSTEN",
    "pl.depreciation": "Abschreibungen (AfA)",
    "pl.ebit": "EBIT",
    "pl.financing": "FINANZIERUNG",
    "pl.interestExpense": "Zinsaufwand",
    "pl.ebt": "EBT (Vorsteuerergebnis)",
    "pl.tax": "STEUERN",
    "pl.incomeTax": "Einkommensteuer",
    "pl.corporateTax": "K\u00f6rperschaftsteuer + GewSt",
    "pl.netIncome": "Jahres\u00fcberschuss",
    "pl.cashFlowSummary": "CASHFLOW-\u00dcBERSICHT",
    "pl.cashFromOperations": "Cashflow aus operativer T\u00e4tigkeit",
    "pl.cashFromInvesting": "Cashflow aus Investitionen",
    "pl.cashFromFinancing": "Cashflow aus Finanzierung",
    "pl.freeCashFlow": "Freier Cashflow",
    "pl.notes": "Anmerkungen",
    "pl.ebitdaNote": "Ergebnis vor Zinsen, Steuern, Abschreibungen auf Sachanlagen und immaterielle Verm\u00f6genswerte",
    "pl.ebitNote": "Betriebsergebnis nach Abschreibungen",
    "pl.freeCashFlowNote": "Tats\u00e4chlich generierte/verbrauchte Barmittel (was auf das Konto ein-/ausgeht)",
    "pl.afaNote": "Abschreibung (AfA) basierend auf Baujahr und Methode. Grund und Boden ist nicht abschreibbar.",
    "bs.title": "Bilanz",
    "bs.subtitle": "Jahresendposition",
    "bs.account": "Konto",
    "bs.year": "Jahr {year}",
    "bs.assets": "AKTIVA",
    "bs.landValue": "Grundst\u00fcckswert",
    "bs.buildingBookValue": "Geb\u00e4ude (Buchwert)",
    "bs.propertyBookValue": "Immobilie (Buchwert)",
    "bs.cash": "Kasse/Bank",
    "bs.reserveFund": "R\u00fccklage",
    "bs.totalAssets": "Bilanzsumme Aktiva",
    "bs.liabilities": "PASSIVA - VERBINDLICHKEITEN",
    "bs.loanBalance": "Darlehensstand",
    "bs.totalLiabilities": "Verbindlichkeiten gesamt",
    "bs.equity": "PASSIVA - EIGENKAPITAL",
    "bs.initialInvestment": "Anfangsinvestition",
    "bs.retainedEarnings": "Gewinnr\u00fccklagen",
    "bs.totalEquity": "Eigenkapital gesamt",
    "bs.economicEquity": "Eigenkapital zu Marktwert (NAV)",
    "bs.checkBalance": "Pr\u00fcfung: Aktiva = Passiva",
    "bs.marketValueSection": "MARKTWERT (Nicht in Bilanz)",
    "bs.landMarketValue": "Grundst\u00fcck (Marktwert)",
    "bs.buildingMarketValue": "Geb\u00e4ude (Marktwert)",
    "bs.estimatedMarketValue": "Gesch\u00e4tzter Marktwert",
    "bs.unrealizedGain": "Stille Reserven",
    "bs.ltv": "Beleihungsauslauf (LTV)",
    "bs.nav": "Nettoverm\u00f6genswert (NAV)",
    "bs.bookVsMarketDelta": "Buch- vs. Marktwertdifferenz",
    "bs.notes": "Anmerkungen",
    "bs.landValueNote": "Grundst\u00fcckswert ist konstant (nicht abschreibbar). Basiert auf Grundst\u00fccksanteil % des Kaufpreises.",
    "bs.buildingBookValueNote": "Geb\u00e4udeanschaffungskosten abz\u00fcglich kumulierter Abschreibungen (AfA)",
    "bs.marketValueNote": "Gesch\u00e4tzter Marktwert basierend auf j\u00e4hrlicher Wertsteigerung (erst bei Verkauf in Bilanz erfasst)",
    "bs.cashNote": "Kumulierter freier Cashflow aus dem Betrieb",
    "bs.reserveFundNote": "Angesammelte Instandhaltungsr\u00fccklage",
    "bs.retainedEarningsNote": "Kumulierter Jahres\u00fcberschuss seit Erwerb",
    "bs.ltvNote": "Darlehen in % des Marktwerts. Sinkt durch Tilgung und Wertsteigerung.",
    "bs.navNote": "Marktwert + Kasse + R\u00fccklagen \u2212 Darlehen. Ihr tats\u00e4chlicher Nettowert.",

    "revenue.energieausweis": "Energieausweis-Klasse",
    "revenue.heatingType": "Heizungsart",
    "revenue.heating.gas": "Gas",
    "revenue.heating.oil": "\u00d6l",
    "revenue.heating.district": "Fernw\u00e4rme",
    "revenue.heating.electric": "Elektro / W\u00e4rmepumpe",
    "revenue.heating.pellet": "Pellet / Biomasse",
    "revenue.kommanditeinlage": "Kommanditeinlage (\u00a715a)",
    "revenue.vatSection": "Umsatzsteuer (USt)",
    "revenue.vatLiable": "Umsatzsteuerpflicht",
    "revenue.vatAuto": "Automatisch (>\u20ac25k = pflichtig)",
    "revenue.vatYes": "Ja (Option zur Regelbesteuerung)",
    "revenue.vatNo": "Nein (Kleinunternehmer)",
    "revenue.hotelServices": "Hotelartige Nebenleistungen",
    "revenue.eigennutzung": "Eigennutzung",
    "revenue.yes": "Ja",
    "revenue.no": "Nein",
    "revenue.vatAutoHint": "Kleinunternehmerregelung: Unter \u20ac25.000 Jahresumsatz wird keine USt erhoben. \u00dcber dieser Schwelle gilt 7% USt auf Beherbergung.",

    "revenue.kirchensteuer": "Kirchensteuer",
    "revenue.kirchensteuerNote": "8% in Bayern/Baden-W\u00fcrttemberg, 9% anderswo. Nur f\u00fcr nat\u00fcrliche Personen.",
    "revenue.otherIncome": "Sonstiges Jahreseinkommen",
    "revenue.otherIncomeHint": "Gehalt oder sonstige Eink\u00fcnfte f\u00fcr Grenzsteuersatzberechnung",

    "pl.werbungskosten": "Werbungskosten",
    "pl.co2LandlordCost": "CO\u2082-Kosten (Vermieteranteil)",
    "pl.lossOffset": "Verlustvortrag (Verrechnung)",
    "pl.vatSection": "UMSATZSTEUER (BILANZNEUTRAL)",
    "pl.vatCollected": "Vereinnahmte USt (7%)",
    "pl.vatInputDeduction": "Vorsteuerabzug",
    "pl.netVAT": "USt-Zahllast",

    "warning.gewerblich": "Gewerblicher Grundst\u00fcckshandel: Verkauf innerhalb von 10 Jahren als Privatperson kann gewerblichen Grundst\u00fcckshandel ausl\u00f6sen (3-Objekte-Grenze). Halten Sie l\u00e4nger.",
    "warning.immo_gmbh_shortterm": "Immo-GmbH + Kurzzeitvermietung: Kurzzeitvermietung schlie\u00dft die erweiterte GewSt-K\u00fcrzung aus. Die Gesellschaft wird wie eine regul\u00e4re GmbH besteuert (volle GewSt).",
    "warning.mopeg": "MoPeG 2026: Seit 01.01.2024 m\u00fcssen GmbH & Co. KGs ins Gesellschaftsregister eingetragen werden. Pr\u00fcfen Sie Ihre Eintragung.",
    "warning.geg_heating": "GEG Heizung: Geb\u00e4ude vor 1994 haben m\u00f6glicherweise \u00d6l-/Gasheizungen, die nach dem Geb\u00e4udeenergiegesetz ersetzt werden m\u00fcssen. Planen Sie Budget f\u00fcr Heizungsmodernisierung ein.",
    "warning.gewst_shortterm": "GewSt-Risiko: Hotelartige Nebenleistungen (Reinigung, W\u00e4sche, Fr\u00fchst\u00fcck) als Privatperson l\u00f6sen Gewerbesteuer auf Kurzzeitvermietungseinnahmen aus (\u20ac24.500 Freibetrag).",
    "warning.section15a": "\u00a715a EStG: Ihre Verschuldung \u00fcbersteigt die Kommanditeinlage. Verluste \u00fcber Ihr Kapitalkonto hinaus sind nicht sofort abzugsf\u00e4hig (verrechenbare Verluste).",
    "warning.highLTV": "Hohe Fremdfinanzierung: Verschuldung \u00fcbersteigt 80% des Kaufpreises. Banken k\u00f6nnen h\u00f6here Zinsen oder zus\u00e4tzliche Sicherheiten verlangen. Erw\u00e4gen Sie mehr Eigenkapital.",
    "warning.lowDSCR": "Niedrige Schuldendienstdeckung: Jahresmiete deckt weniger als 125% der Darlehenszahlungen. Liquidit\u00e4tsengp\u00e4sse in fr\u00fchen Jahren wahrscheinlich. Ausreichende R\u00fccklagen sicherstellen.",
    "warning.abgeltungsteuer": "Aussch\u00fcttungssteuer: Die gezeigten Gewinne sind nach KSt (15,825%). Bei Dividendenaussch\u00fcttung f\u00e4llt zus\u00e4tzlich 26,375% Abgeltungsteuer auf Personenebene an (effektiver Gesamtsteuersatz ~48,3%)."
  }
};

export default statementsTranslations;
